export default __webpack_public_path__ + "static/media/cave.2bf0223b.JPG";